// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"73799b37","193":"3d50cee8","590":"513b3432","607":"6c6a9425","641":"4401536b","676":"edd4cacd","899":"1bd29e3f"}[chunkId] + ".chunk.js";
};